import { useQuery } from '@tanstack/react-query';

import { getAttractionImages } from '~/services/AttractionsService';

import { attractionQueryKeys } from './attractionQueryKeys';

interface UseGetAttractionImagesOptions {
  enabled?: boolean;
}

/**
 * Fetches available images from linked offers for the image picker.
 */
export function useGetAttractionImages(attractionId: string, options: UseGetAttractionImagesOptions = {}) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: attractionQueryKeys.images(attractionId),
    queryFn: async ({ signal }) => {
      return await getAttractionImages(attractionId, { signal });
    },
    enabled: enabled && !!attractionId,
    retry: false,
  });
}
